import { CurrencyCode } from '../currency';

export interface CalculatorDataDto {
  termsUrl: string;
  availableOffers: CalculatorOffer[];
  currencyCode: CurrencyCode;
  error: CalculatorError | null;
}

export enum CalculatorError {
  NO_OFFER_AVAILABLE = 'NO_OFFER_AVAILABLE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  UNKNOWN = 'UNKNOWN',
}

export interface CalculatorOffer {
  monthlyCost: number;
  numberOfMonths: number;
  nominalInterest: number;
  totalAmount: number;
  effectiveInterest: number;
  initialFee: number;
  monthlyFee: number;
  initialAmount: number;
}

export interface CalculatorTexts {
  monthlyCost: string;
  nominalAndEffectiveInterest: string;
  totalInterestFee: string;
  adminFee: string;
  initialFee: string;
  totalAmount: string;
  proceed: string;
  stepOne: string;
  stepTwo: string;
  stepThree: string;
  done: string;
  termsOne: string;
  termsTwo: string;
  termsThree: string;
  month: string;
  currencyCode: string;
  offerError: string;
  error: string;
  infoMessage: string;
  calculations: string;
}
